/**
 * Filter types for the Positions Page.
 */

/** Position status filter options */
export type PositionStatusFilter = 'all' | 'ACTIVE' | 'CLOSED';

/** Date field to filter on */
export type DateFieldFilter = 'created_at' | 'closed_at';

/**
 * Position filter state.
 * All filters are applied with AND logic.
 */
export interface PositionFilterState {
  /** Symbol filter (case-insensitive partial match) */
  symbol: string;
  /** Position status filter */
  status: PositionStatusFilter;
  /** Which date field to filter on */
  dateField: DateFieldFilter;
  /** Start date for range filter (YYYY-MM-DD format) */
  startDate: string | null;
  /** End date for range filter (YYYY-MM-DD format) */
  endDate: string | null;
}

/** Default filter values */
export const DEFAULT_FILTERS: PositionFilterState = {
  symbol: '',
  status: 'all',
  dateField: 'created_at',
  startDate: null,
  endDate: null,
};
